<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners"
    class="device-receipt-record-img-list-dialog">
    <div class="dialog-body">
      <div class="img-list">
        <t-upload type="file" v-model="imgData" :bizId="model.data.orderDeliveryMonthId" bizType="deliveryMonth" :disabled="true"></t-upload>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// 查看签收单图片
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload';

export default {
  mixins: [dialogMixins],
  components: {
    tUpload
  },
  data() {
    return {
      imgData: [

      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const list = await this.$getFileList({
        bizId: this.model.data.orderDeliveryMonthId,
        bizType: 'deliveryMonth'
      });

      this.imgData = list;

    },
    onConfirm() {

    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss">
.device-receipt-record-img-list-dialog {
  .img-list {
    overflow: hidden;

    .img-item {
      float: left;
      margin-right: 18px;
    }
  }
}
</style>
